module.exports = __webpack_public_path__ + "static/img/s4.debdf49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/s4.png
// module id = I5fz
// module chunks = 0